export const installMock = () => {
  if (process.env.NODE_ENV === 'development') {
    const {worker} = require('../mocks/browser');
    worker.stop();
  }
};
